/**
 * The RMS's places, in one list.
 *
 * The sidebar, the tab bar along a phone's foot and the search's
 * shortcuts all list them, so the list is here once rather than three
 * times. The first is Home: `/` goes to Events.
 */
import type { ReactNode } from "react";
import { CalendarIcon, ClipboardListIcon, PackageIcon } from "./icons";

export interface Destination {
  to: string;
  label: string;
  icon: ReactNode;
}

/**
 * Events are the jobs, quote to settlement; Schedule is every Booking's
 * gear, vehicles and crew over a date window; Equipment is the catalogue.
 * A stage of a job is a view of Events, never a place of its own
 * (DESIGN-SYSTEM.md, Admin list pages).
 */
export const DESTINATIONS: Destination[] = [
  { to: "/events", label: "Events", icon: <ClipboardListIcon /> },
  { to: "/schedule", label: "Schedule", icon: <CalendarIcon /> },
  { to: "/equipment", label: "Equipment", icon: <PackageIcon /> },
];

/** A destination is active on its own page and on its detail routes. */
export function isActiveDestination(pathname: string, to: string): boolean {
  return pathname === to || pathname.startsWith(`${to}/`);
}
